<!-- @Version: 1.1.0 -->
<div class="page-wrapper"   cdkTrapFocus>
   <div class="center">
      <h2 id="icon-describe" [attr.color]="path + TRANSLATE_PATH.NO_MOBILE_ICON_COLOR | translateDesign">{{path + TRANSLATE_PATH.NO_MOBILE_TITLE | translateDesign}}</h2>
      @if ((path + TRANSLATE_PATH.NO_MOBILE_ICON_TYPE | translateDesign) != path + (TRANSLATE_PATH.NO_MOBILE_ICON_TYPE | translateDesign)) {
         <mat-icon aria-describedby="icon-describe" [color]="path + TRANSLATE_PATH.NO_MOBILE_ICON_COLOR | translateDesign" data-width="fit-content" class="special-page">{{path + TRANSLATE_PATH.NO_MOBILE_ICON_TYPE | translateDesign}}</mat-icon>
      }
      <h3 [attr.color]="path + TRANSLATE_PATH.NO_MOBILE_ICON_COLOR | translateDesign">{{path + TRANSLATE_PATH.NO_MOBILE_MESSAGE | translateDesign}}</h3>
   </div>
</div>